module.exports = __webpack_public_path__ + "static/media/t13.5719a853.jpg";